export enum OptionActiveSituationEnum {
    ENABLED = 'Ativo',
    DISABLED = 'Inativo',
}

export type OptionActiveSituation = 'ENABLED' | 'DISABLED';
